// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("C:\\Users\\xshau\\Documents\\Websites (temp)\\stellar-diz\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\xshau\\Documents\\Websites (temp)\\stellar-diz\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-plugins-js": () => import("C:\\Users\\xshau\\Documents\\Websites (temp)\\stellar-diz\\src\\pages\\plugins.js" /* webpackChunkName: "component---src-pages-plugins-js" */)
}

